module.exports = __webpack_public_path__ + "static/media/EnvironmentBanner.643d8832.svg";